// extracted by mini-css-extract-plugin
export default {"container":"ODD2Ny","select":"HkcheW","share-buttons":"Sg15Ln","shareButtons":"Sg15Ln","icon":"b_5VOy"};